import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { rem, size } from 'polished';
import screen from 'superior-mq';
import { bp } from 'Styles/helpers';
import objectPath from 'object-path';
import Section from '../../section';
import Container from '../../container';
import TextWave from '../../text-wave';
import Subhead from '../../subhead';
import LazyImg from '../../lazy-img';
import Waves from '../../waves';
import PurposeCarousel from '../../purpose-carousel';
import HomeH3 from '../HomeH3';
import RenderMd from '../../render-md/RenderMd';
import ImageSlideIn from '../../image-slide-in';

const sectionStyles = `
  padding-bottom: 20px;
  position: relative;

  ${screen.below(bp.desktop, `
    padding-bottom: 20px;
  `)}

  ${screen.below(bp.laptopSm, `
    padding-bottom: 10px;
  `)}
`;

const Badge = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 208.7 208.7" fill="currentColor"><path d="M137.9 13.4l-1.7-.6.3-3.9c0-.3.2-.8.2-.8s-.2.5-.3.8l-2.1 3.3-1.7-.6.7-7.6 2.1.7-.7 4.1c-.1.3-.2 1-.2 1s.2-.6.4-.9l2.1-3.7 1.6.6-.6 4.2c0 .3-.2.9-.2.9s.2-.6.4-.9l1.9-3.7 1.8.6-4 6.5z" /><path d="M148.1 17.9l.3-1.4-1.5-.7-.9 1.1-1.8-.9 5.1-5.8 2.1 1-1.5 7.6-1.8-.9zm1.3-4.9c.1-.3.2-.7.2-.7s-.2.4-.5.6l-1.4 1.8 1.1.5.6-2.2z" /><path d="M157.8 23.6l-1.8-1.2 2.4-7.4 1.8 1.2-1.6 4.1-.5 1s.5-.6.7-.9l3-3.1 1.7 1.1-5.7 5.2z" /><path d="M164.2 28.2l4.7-5.8 3.3 2.7-1 1.2-1.8-1.5-.9 1.1 1.5 1.2-.9 1.1-1.5-1.2-1 1.2 1.8 1.5-1 1.2-3.2-2.7z" /><path d="M173.3 36.5c-.6-.6-1-1.2-1.1-1.9l1.4-1c.1.7.4 1.3.8 1.8.3.3.6.3.9.1.8-.8-1.1-2.6.6-4.2.9-.9 2.2-.9 3.3.3.5.5.9 1.2 1.1 1.7l-1.3 1c-.2-.6-.5-1.2-.9-1.5-.3-.3-.6-.3-.8-.1-.7.7 1.1 2.6-.5 4.2-.9.9-2.3.8-3.5-.4z" /><path d="M187.4 51.3l-1.4.9-1-1.5 1.4-.9-1.5-2.2 1-.9c1.5-.1 3.6-.1 5.3-.1l1 1.4-3.6 2.4.5.7-1.2.8-.5-.6zm-.4-3.1l.6 1 1.7-1.1c-.6-.1-1.6 0-2.3.1z" /><path d="M195.4 71.1l-.7-1.7 3.2-2.3c.2-.1.7-.4.7-.4s-.5.2-.8.2l-3.9.6-.7-1.7 6.3-4.4.8 2-3.6 2.1c-.3.2-.9.4-.9.4s.6-.2 1-.3l4.2-.6.6 1.6-3.5 2.4c-.3.2-.8.4-.8.4l.9-.3 4.1-1 .7 1.9-7.6 1.1z" /><path d="M198.5 81.8l1.3-.7-.4-1.6h-1.5l-.5-2 7.7.2.6 2.3-6.8 3.8-.4-2zm4.6-2.2c.3-.1.7-.3.7-.3s-.4.1-.8.1l-2.2.1.3 1.2 2-1.1z" /><path d="M206.3 91.5l-5.8.8-.3-2 5.8-.8-.2-1.5 1.6-.2.7 5-1.6.2-.2-1.5z" /><path d="M201.1 99.9l7.5-.2.1 4.3h-1.5l-.1-2.3h-1.4v1.9h-1.5v-1.9h-1.5l.1 2.4h-1.6l-.1-4.2z" /><path d="M200.7 113.9c2.3-.3 2.7-.4 2.9-.7l.1-.6-2.8-.3.2-1.9 7.4.7s-.1 1.4-.2 2.7c-.2 1.8-1.1 2.5-2.3 2.4-1-.1-1.7-.7-1.9-1.3-.2.4-.8.7-3.6 1.2l.2-2.2zm6.2-.6v-.4l-2-.2-.1.9c.2.2.5.5 1 .5.7.1 1.1-.2 1.1-.8z" /><path d="M200.3 129.7l1.5.4-.6 2.2-1.5-.4.6-2.2z" /><path d="M191.6 146.2l1-2 6.7 3.3s-.5 1.2-1 2.3c-1 2-2.7 2.4-4.7 1.4-2.2-1.1-3-2.9-2-5zm5.4 2.7c.1-.2.1-.4.1-.4l-4-1.9-.2.4c-.4.8.3 1.7 1.4 2.2 1.4.6 2.3.6 2.7-.3z" /><path d="M185.5 157c1.2-1.8 3.1-1.6 4.8-.4 1.8 1.2 2.8 3 1.5 4.9-1.2 1.8-3 1.6-4.8.5-1.9-1.2-2.8-3-1.5-5zm5 3.5c.3-.5-.2-1.4-1.3-2.1-1.2-.8-2.2-.9-2.6-.4-.3.5.2 1.4 1.3 2 1.3.9 2.3 1 2.6.5z" /><path d="M170.4 175.2l1.3-1.3 3.3 2.1c.2.1.6.5.6.5s-.4-.4-.5-.7l-2-3.4 1.3-1.3 6.5 4.1-1.6 1.5-3.4-2.5c-.3-.2-.7-.6-.7-.6s.4.5.6.8l2.3 3.6-1.2 1.2-3.5-2.3c-.3-.2-.7-.6-.7-.6s.4.5.6.7l2.5 3.4-1.4 1.4-4-6.6z" /><path d="M161.6 182.5l1.8 2.4 1.4-1-1.8-2.4 1.6-1.2 4.5 6-1.6 1.2-1.7-2.3-1.4 1 1.7 2.3-1.6 1.2-4.5-6 1.6-1.2z" /><path d="M151.2 189.1l1 1.1 1.4-.8-.4-1.4 1.8-1 1.9 7.5-2.1 1.2-5.5-5.5 1.9-1.1zm3.4 3.8c.2.3.5.6.5.6s-.2-.4-.3-.7l-.7-2.1-1 .6 1.5 1.6z" /><path d="M143.9 199.2l-2.3-5.4 1.8-.8 2.3 5.4 1.4-.6.6 1.5-4.6 2-.6-1.5 1.4-.6z" /><path d="M125 202l-.6-2.9 2-.4.6 2.9 3 4-2.2.5-1.5-2.6-.3 2.9-2 .4 1-4.8z" /><path d="M114.2 200.6c2.1-.2 3.2 1.4 3.4 3.5.2 2.2-.6 4-2.9 4.2-2.1.2-3.2-1.4-3.4-3.5-.2-2.2.6-4 2.9-4.2zm.5 6.1c.6-.1.9-1 .8-2.3-.1-1.4-.6-2.3-1.3-2.2-.6.1-.9 1-.8 2.3.1 1.3.6 2.2 1.3 2.2z" /><path d="M102 201c1.8 0 2.7 1 2.7 2.6l-.1 5.1-2-.1.1-4.8c0-.8-.4-1.1-.8-1.2-.4 0-.8.3-.8 1.1l-.1 4.8-2-.1.1-4.9c-.1-1.5.9-2.5 2.9-2.5z" /><path d="M85.3 199.3l-1.6 7.3-2-.4 1.2-5.7-2.1-.5.4-1.7 4.1 1z" /><path d="M73.1 195.9c2 .7 2.3 2.6 1.6 4.6-.7 2.1-2.2 3.4-4.4 2.7-2-.7-2.3-2.6-1.6-4.5.8-2.2 2.2-3.6 4.4-2.8zm-2.1 5.8c.6.2 1.3-.6 1.7-1.8.5-1.3.4-2.4-.2-2.6-.6-.2-1.3.6-1.7 1.7-.4 1.4-.4 2.5.2 2.7z" /><path d="M61.2 191.1l1.9.9-1.5 7.6-2-1 1.1-4.2c.1-.4.4-1.1.4-1.1s-.4.7-.6 1l-2.6 3.5-1.8-.9 5.1-5.8z" /><path d="M54.2 187.3l-4 6.3-3.6-2.3.8-1.3 2 1.2.8-1.2-1.6-1 .8-1.2 1.6 1 .8-1.3-2-1.3.8-1.3 3.6 2.4z" /><path d="M37.2 174.1l-.7 1.3 1.2 1.1 1.2-.8 1.5 1.4-6.6 4-1.7-1.6 3.6-6.8 1.5 1.4zm-2.7 4.4l-.4.6s.3-.3.6-.5l1.9-1.3-.9-.8-1.2 2z" /><path d="M29.1 165.3l-1.6 3.7c-.1.3-.4.7-.4.7l.6-.6 2.7-2.3 1.2 1.4-5.8 4.8-1.2-1.4 1.5-3.7c.1-.3.5-.8.5-.8l-.7.7-2.6 2.2-1.2-1.4 5.8-4.8 1.2 1.5z" /><path d="M22.8 156.6c.6.9 1.2 2 1.2 2l-6.3 4s-.8-1.1-1.4-2.1c-1.2-1.9-.6-3.5 1.2-4.7 2.2-1.4 4.1-1.3 5.3.8zm-5.1 3.1c.1.2.2.3.2.3l3.7-2.4s-.1-.2-.2-.3c-.5-.7-1.5-.7-2.6.1-1.2.7-1.6 1.5-1.1 2.3z" /><path d="M13.5 138l-2.8 1.1.6 1.6 2.8-1.1.7 1.9-7 2.7-.7-1.9 2.7-1-.6-1.6-2.7 1-.7-1.9 7-2.7.7 1.9z" /><path d="M10.9 129.8l-7.3 1.8-1-4.2 1.5-.4.6 2.3L6 129l-.5-1.9 1.4-.4.5 1.9 1.5-.4-.6-2.3 1.5-.4 1.1 4.3z" /><path d="M8.7 119.4l-7.4 1-.3-2 5.7-.8-.3-2.1 1.7-.2.6 4.1z" /><path d="M5.2 106.8v.5l2.4-.1v2l-7.5.2s-.1-1.2-.1-2.5c0-1.8.9-2.8 2.3-2.8 1.7 0 2.8 1.1 2.9 2.7zm-3.8.3v.3l2.3-.1v-.4c0-.6-.5-.9-1.2-.9-.6.1-1.1.5-1.1 1.1z" /><path d="M9.1 87H7.6l-.3 1.6 1.3.5-.3 2-7-3.3.4-2.3 7.7-.8-.3 2.3zm-5.1.1h-.8s.4.1.7.3l2.1.8.2-1.2-2.2.1z" /><path d="M10.9 79l-7.2-2.1.5-1.9 5.6 1.6.6-2 1.6.4-1.1 4z" /><path d="M15.1 67.1c-.8 2-2.7 2.1-4.6 1.3-2-.8-3.3-2.4-2.4-4.6.8-2 2.7-2.1 4.6-1.3 2 .9 3.3 2.4 2.4 4.6zm-5.6-2.5c-.2.6.5 1.3 1.6 1.8 1.3.5 2.3.5 2.6-.1.2-.6-.5-1.3-1.6-1.8-1.4-.5-2.4-.5-2.6.1z" /><path d="M21 55.1l-4.1-.2c-.3 0-.8-.2-.8-.2s.5.2.8.4l3.1 1.7-.9 1.6-6.5-3.7.9-1.6 4 .2c.3 0 .9.2.9.2s-.5-.2-.9-.4l-3-1.6.9-1.6 6.5 3.7-.9 1.5z" /><path d="M28.2 44.4c-.2.4-.4.8-.8 1.3-1.4 1.8-3.1 1.7-4.9.3-1.8-1.4-2.6-3.3-1.1-5.2.5-.6 1.2-1.2 1.7-1.4l1.2 1.1c-.5.3-1.2.7-1.5 1.2-.6.8-.1 1.8.8 2.5 1.2.9 2.1 1 2.7.3.1-.1.2-.3.3-.5l-.9-.7-.5.7-1.1-.8 1.6-2.1 2.9 2.2c-.1.4-.3.7-.4 1.1z" /><path d="M36.4 27.3l4 4.3-1.5 1.4-4-4.3-1.1 1-1.1-1.2 3.7-3.4 1.1 1.2-1.1 1z" /><path d="M49.3 24.7l-1.7-2.4-1.4 1 1.7 2.4-1.6 1.1-4.3-6.1 1.6-1.1 1.6 2.3 1.4-1-1.6-2.3 1.6-1.2 4.3 6.1-1.6 1.2z" /><path d="M56.6 20.1L53 13.5l3.8-2 .7 1.3-2.1 1.1.7 1.2 1.7-.9.7 1.3-1.7.9.7 1.3 2.1-1.1.7 1.4-3.7 2.1z" /><path d="M79.4 10.7l-1.8.5-2-3.4c-.1-.2-.3-.8-.3-.8s.1.6.2.8l.2 3.9-1.8.5-3.8-6.7 2.1-.6 1.8 4c.1.3.4.9.4.9s-.2-.6-.2-1l-.4-4.2 1.7-.5 2 3.7c.2.3.4.9.4.9s-.1-.6-.2-.9l-.6-4.1 1.9-.6.4 7.6z" /><path d="M90.3 8.5l-.5-1.4-1.6.3-.1 1.4-2 .3.9-7.7 2.3-.4 3.2 7.1-2.2.4zm-1.8-4.7l-.2-.8v.8L88.2 6l1.2-.2-.9-2z" /><path d="M101 4.6l.1 3-2 .1-.1-3L96.7.2H99l1 2.8.8-2.9 2.1-.1-1.9 4.6z" /><path d="M116.4 5.9l.2-1.5 2.2.3-.2 1.5-2.2-.3z" /><g><path d="M86.6 121.5l-4.3-13.1h-4.6l-4.3 13.1-4-13h-6l.2.6 7.2 21.4h4.7l4.4-12.6 4.4 12.6H89l7.5-22h-5.8l-4.1 13z" /><path d="M139.5 108.6l-4 13-4.3-13.1h-4.7l-4.3 13.1-4-13h-6l.2.6 7.2 21.4h4.7l4.4-12.6 4.4 12.6h4.7l7.5-22h-5.8z" /><path d="M100.2 125.7c0 2.3 1.9 4.2 4.2 4.2 2.3 0 4.2-1.9 4.2-4.2.1-3.6-4.2-5-4.2-8.4 0 3.4-4.2 4.7-4.2 8.4z" /></g><path d="M122.4 83.5c-5.7 0-10.4 4.7-10.4 10.4v.4h5.9v-.4c0-2.5 2-4.4 4.4-4.4 2.5 0 4.4 2 4.4 4.4 0 2.5-2 4.4-4.4 4.4h-14.6V78.1h-6.1l-18.1 21v5.1h17.3v9.9h6.9v-9.9h14.6c5.7 0 10.4-4.7 10.4-10.4s-4.5-10.3-10.3-10.3zm-21.5 14.9h-8.8l8.8-10.3v10.3z" /></svg>
);

export default class Purpose extends PureComponent {

  static propTypes = {
    subheading: PropTypes.string,
    title: PropTypes.string,
    largeText: PropTypes.string,
    subTitle: PropTypes.string,
    content: PropTypes.string,
    images: PropTypes.array,
    carousel: PropTypes.array,
  }

  static defaultProps = {
    images: [],
  };

  render() {
    const {
      subheading,
      title,
      largeText,
      subTitle,
      content,
      images,
      carousel,
    } = this.props;
    const [image1, image2, image3] = images;
    const imgParams = 'w=516&h=346&q=80&fm=jpg&fl=progressive';

    return (
      <Section styles={sectionStyles}>
        <Waves
          position="top"
          bleed
          alignment="bottom"
          height={100}
          style={{ top: 0, bottom: 'auto' }}
        />
        <Container>
          <Subhead>{subheading}</Subhead>
          <TextWave>
            <HomeH3>
              {title}
            </HomeH3>
          </TextWave>

          <div style={{ position: 'relative', zIndex: 1 }}>
            <ImageSlideIn>
              <MegaH4>{largeText}</MegaH4>

              <Blamo ref={this.imagesRef}>

                {objectPath.has(image3, 'fields.file.url') &&
                  <BlamoImg className="js-slide-image" three>
                    <LazyImg
                      src={`${image3.fields.file.url}?${imgParams}`}
                      width={508}
                      height={340}
                      alt={image3.fields.description}
                    />
                  </BlamoImg>
                }

                {objectPath.has(image2, 'fields.file.url') &&
                  <BlamoImg className="js-slide-image" two>
                    <LazyImg
                      src={`${image2.fields.file.url}?${imgParams}`}
                      width={442}
                      height={296}
                      alt={image2.fields.description}
                    />
                  </BlamoImg>
                }

                {objectPath.has(image1, 'fields.file.url') &&
                  <BlamoImg className="js-slide-image" one>
                    <LazyImg
                      src={`${image1.fields.file.url}?${imgParams}`}
                      width={508}
                      height={340}
                      alt={image1.fields.description}
                    />
                  </BlamoImg>
                }

                <BadgeWrap>
                  <Badge />
                </BadgeWrap>
              </Blamo>
            </ImageSlideIn>

          </div>

          <PurposeContent>
            <h5>{subTitle}</h5>
            <RenderMd source={content} />
          </PurposeContent>

        </Container>

        <PurposeCarousel slides={carousel} />
      </Section>
    );
  }
}

const Blamo = styled.div`
  position: relative;
  width: 1076px;
  max-width: 80%;
  margin: 140px auto;

  ${screen.below(bp.laptopSm, `
    margin: 100px auto;
  `)}

  ${screen.below(bp.portrait, `
    max-width: 100%;
    margin: 80px auto 70px;
  `)}

  ${screen.below(bp.mobileSm, `
    max-width: 100%;
    margin: 50px auto 70px;
  `)}

  &::after {
    content: "";
    display: block;
    width: 100%;
    padding-bottom: 52%;
  }
`;

const BadgeWrap = styled.div`
  ${size('210px')}
  position: absolute;
  top: 2%;
  right: 13%;

  ${screen.below(bp.laptop, css`
    ${size('180px')}
  `)}

  ${screen.below(bp.laptopSm, css`
    ${size('160px')}
  `)}

  ${screen.below(bp.tablet, css`
    ${size('120px')}
  `)}

  ${screen.below(bp.mobileSm, css`
    ${size('60px')}
  `)}
`;

const BlamoImg = styled.div`
  position: absolute;
  width: 48%;
  left: 0;
  right: 0;
  top: 0;
  margin: 0 auto;
  transform-origin: 30% 30%;

  ${props => props.one && css`
    box-shadow: 21px 51px 39.2px 9.8px rgba(0, 0, 0, 0.09);
    transform: translateX(-50%) rotate(-16deg);
  `}

  ${props => props.two && css`
    box-shadow: 18px 45px 50px 10px rgba(0, 0, 0, .16);
    transform: rotate(5deg);
    transform: translateX(-12.5%) translateY(71%) rotate(5deg);

    ${screen.below(bp.portrait, `
      box-shadow: 18px 45px 50px 10px rgba(0, 0, 0, .08);
    `)};
  `}

  ${props => props.three && css`
    transform: translateX(41.667%) translateY(33.333%) rotate(4deg);
    box-shadow: 8px 19px 38px 10px rgba(0, 0, 0, .08);
  `}
`;

const MegaH4 = styled.h4`
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  font-size: calc((var(--container)) / 4.8);
  mix-blend-mode: multiply;
  color: ${props => props.theme.blue};
  white-space: nowrap;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: geometricPrecision;
  z-index: 2;
  letter-spacing: -.05em;

  ${screen.below(bp.portrait, css`
    font-size: 20vw;
  `)}

  ${screen.below(bp.portrait, css`
    transform: translateX(-50%);
    font-size: 23vw;
  `)}
`;

const PurposeContent = styled.div`
  max-width: 800px;
  text-align: center;
  margin: auto;

  h5 {
    font-family: ${props => props.theme.sansFont};
    font-size: ${rem(44)};
    line-height: 1.1;
    margin: 0 40px 60px;

    ${screen.below(bp.laptopSm, css`
      font-size: ${rem(32)};
      margin: 0 80px 30px;
    `)}

    ${screen.below(bp.mobile, css`
      margin: 0 60px 30px;
    `)}

    ${screen.below(bp.mobileSm, `
      font-size: ${rem(25)};
      margin: 0 auto 30px auto;
    `)}
  }
`;
